import { Modal, Button } from 'antd';
import { FC } from 'react';
import TotalCashToCloseTable from '../TotalCashToCloseTable';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
}

const TotalCashToCloseDetailsModal: FC<Props> = ({ isOpen, onCancel }) => (
  <Modal
    centered
    open={isOpen}
    title="Total Cash To Close Details"
    onCancel={onCancel}
    width="fit-content"
    style={{ maxWidth: 'calc(100% - 40px)' }}
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Close
      </Button>,
    ]}
  >
    <TotalCashToCloseTable />
  </Modal>
)

export default TotalCashToCloseDetailsModal;
